import React from 'react'
import styles from './index.module.scss'
import { Check } from '../../../../../assets/NewDashboard'

const ResultsTable = ({
  groupedStructure,
  totalRow,
  totals,
  formatLabour,
  formatFgosTotal
}) => {
  return (
    <div className={styles.structureSection}>
      <div className={styles.structureHeader}>
        <h3>Требования к образовательной программе</h3>
        <div className={styles.legend}>
          <Check mode="notComplete" />
          <span>— не соответствует требованиям ФГОС/КТ</span>
        </div>
      </div>

      <table className={styles.structureTable}>
        <thead>
          <tr>
            <th rowSpan={2}>Название блока, дисциплины, практики</th>
            <th colSpan={3}>Трудоёмкость, з.е. (акад. час)</th>
            <th colSpan={3}>Требования ФГОС</th>
            <th>Требования КТ</th>
          </tr>
          <tr>
            <th>Всего, З.Е. (ак. час)</th>
            <th>Баз.</th>
            <th>Вар.</th>
            <th>Всего, З.Е. (ак. час)</th>
            <th>Баз.</th>
            <th>Вар.</th>
            <th>Всего, з.е. (акад. час)</th>
          </tr>
        </thead>
        <tbody>
          {groupedStructure.map((block) => (
            <React.Fragment key={block.block_id}>
              <tr className={styles.blockRow}>
                <td>{block.block_index}. {block.block_name}</td>
                <td className={block.fgos_check == false ? styles.errorCellBlock : ''}>
                  {formatLabour(block.labour_intensity_ze, block.hours)}
                  {block.fgos_check == false && <Check mode="notComplete" />}
                </td>
                <td>{block.base_labour}</td>
                <td>{block.var_labour}</td>
                <td>{formatFgosTotal(block)}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              {block.courses.map((course, idx) => (
                <tr key={`${block.block_id}-${idx}`} className={styles.courseRow}>
                  <td className={course.kt_check == false ? styles.errorName : ''}>
                    {course.course_name}
                    {course.kt_check == false && <Check mode="notComplete" />}
                  </td>
                  <td className={course.fgos_check == false ? styles.errorCell : ''}>
                    {formatLabour(course.labour_intensity_ze, course.hours)}
                    {course.fgos_check == false && <Check mode="notComplete" />}
                  </td>
                  <td>{course.base_labour}</td>
                  <td>{course.var_labour}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
            </React.Fragment>
          ))}
          {totalRow && (
            <tr className={styles.totalRow}>
              <td>Всего</td>
              <td className={totalRow.fgos_check == false ? styles.errorCell : ''}>
                {formatLabour(totals.ze, totals.hours)}
                {totalRow.fgos_check == false && <Check mode="notComplete" />}
              </td>
              <td>{totals.baseZe || ''}</td>
              <td></td>
              <td>{formatFgosTotal(totalRow)}</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default ResultsTable
